enum DMVColorType{
        'Fact'='#c76e1f',
        'Dimension'='#B2AE36',
        'UNDEFINED'='grey',
        'DimensionTypeDimandFactData'='purple',
        default='#3626A7'
}


export default DMVColorType;